/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { AnalyticEvents } from '@euler/generated/AnalyticEvents';
import { mixpanel } from '@euler/lib/integration/mixpanel';
import { makeDebug } from '@euler/utils';

const debug = makeDebug('analytics');

export function setupAnalytics() {
  AnalyticEvents.default.addEventListener((event, props) => {
    debug("captured analytic event '%s': %O", event, props);
    mixpanel.track(event, props);
  });
}
